var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConcat = function SvgConcat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "concat_svg2__a",
    x1: -16.58,
    x2: 125.16,
    y1: 147.66,
    y2: 26.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#concat_svg2__a",
    id: "concat_svg2__b",
    x1: 36.55,
    x2: 178.29,
    y1: 209.98,
    y2: 89.13
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#concat_svg2__a",
    id: "concat_svg2__c",
    x1: -10.75,
    x2: 130.99,
    y1: 154.5,
    y2: 33.65
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#concat_svg2__a",
    id: "concat_svg2__d",
    x1: -6.22,
    x2: 135.52,
    y1: 159.81,
    y2: 38.97
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m81 137.29-31.09 25.92v-20.43c0-3.94-3.19-7.13-7.13-7.13H21.39c-3.94 0-7.13-3.19-7.13-7.13v-92.7c0-3.94 3.19-7.13 7.13-7.13H164c3.94 0 7.13 3.19 7.13 7.13v21.39h14.26V35.82c0-11.81-9.58-21.39-21.39-21.39H21.39C9.58 14.43 0 24.01 0 35.82v92.7c0 11.82 9.58 21.39 21.39 21.39h14.26v28.52c0 2.76 1.6 5.28 4.1 6.45a7.142 7.142 0 0 0 7.59-.96l40.79-34.01h18.82v-14.26H85.56c-1.67 0-3.28.58-4.56 1.64",
    style: {
      fill: "url(#concat_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.96 70.02c-8.56-8.02-21.86-8.02-30.42 0l-46.35 46.35a7.1 7.1 0 0 0-2.1 5.03v21.39c0 3.94 3.19 7.13 7.13 7.13h21.39c1.89 0 3.7-.76 5.03-2.1l46.35-46.35c8.4-8.97 7.94-23.05-1.03-31.45m-9.03 21.39-44.28 44.25h-11.3v-11.3l44.25-44.28a8.026 8.026 0 0 1 11.34.4 8.027 8.027 0 0 1 0 10.94Z",
    style: {
      strokeWidth: 0,
      fill: "url(#concat_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.2 65.44c0-2.76-2.24-5-5-5h-85c-2.76 0-5 2.24-5 5s2.24 5 5 5h85c2.76 0 5-2.24 5-5",
    style: {
      strokeWidth: 0,
      fill: "url(#concat_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 87.44c-2.76 0-5 2.24-5 5s2.24 5 5 5h43.2c2.76 0 5-2.24 5-5s-2.24-5-5-5z",
    style: {
      strokeWidth: 0,
      fill: "url(#concat_svg2__d)"
    }
  }));
};
export default SvgConcat;